// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"ja_a bik_vu bik_ql bik_va bik_gy bik_kg bik_sv","ProfileAdminTools__item":"ja_b"};